export const TAGS = [
  "a",
  "button",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "span",
  "ol",
  "ul",
  "label",
] as const;

export type Tag = (typeof TAGS)[number];

export const getSafeTag = (tag: any, fallback: Tag = "span") => {
  return TAGS.includes(tag as any) ? (tag as Tag) : fallback;
};
